import { render, staticRenderFns } from "./GeneralSituation.vue?vue&type=template&id=5383124d&scoped=true"
import script from "./GeneralSituation.vue?vue&type=script&lang=js"
export * from "./GeneralSituation.vue?vue&type=script&lang=js"
import style0 from "./GeneralSituation.vue?vue&type=style&index=0&id=5383124d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5383124d",
  null
  
)

export default component.exports